import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Order } from 'models/order';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CartService } from '../cart/cart.service';
import { ConfigurationService } from '../configuration/configuration.service';
import { RestApiService } from '../rest-api/rest-api.service';
import { UrlService } from '../url/url.service';
import { environment as env } from '../../../../../src/environments/environment';

@Injectable({ providedIn: 'root' })
export class OrderService {
    private _$order: BehaviorSubject<any> = new BehaviorSubject([]);
    public portalId: string;
    public failingCourseList = [];

    constructor(
        private http: HttpClient,
        public _restApi: RestApiService,
        private _urlService: UrlService,
        private _cartService: CartService,
        private config: ConfigurationService,
        private _restApiService: RestApiService
    ) {}

    public get order$(): Observable<Order> {
        return this._$order.asObservable();
    }

    updateOrder(order: Order) {
        let _site = this.config.getCurrentSite();
        if (this.config.isPartnerPage()) {
            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }

        this._$order.next(order);
        if (order && order.cartItems && order.cartItems.length > 0) {
            localStorage.setItem(`order${_site}`, this._urlService.encode(JSON.stringify(order)));
        } else {
            localStorage.removeItem(`order${_site}`);
        }
    }

    submitOrder(order: Order, totalprice) {
        let _site = this.config.getCurrentSite();
        let _site1 = this.config.getCurrentSite();

        let params = '';
        if (this.config.isPartnerPage()) {
            // todo: change to portalId when backend is adjusted
            // _site = 'de_de';

            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    this.portalId = portalId;
                    const temp = portalId.toLocaleUpperCase().replace('-', '_').replace('-', '_');
                    params = `?portalName=${temp}&countryCode=null`;
                    _site = portalId.toLocaleUpperCase().replace('-', '_').replace('-', '_');
                    _site1 = portalId;
                }
            });
        } else {
            params = `?countryCode=${_site}&portalName=null`;
        }

        let cartItems = {
            courses: [],
            events: [],
            wishlist: []
        };

        if (localStorage.getItem(`cartItems${_site1}`)) {
            cartItems = JSON.parse(this._urlService.decode(localStorage.getItem(`cartItems${_site1}`)));
            this._urlService.encode(JSON.stringify(localStorage.setItem('eventsHotels', localStorage.getItem(`cartItems${_site1}`))));
        }
        let orderObj;
        if (this.config.isPartnerPage()) {
            const lang = JSON.parse(sessionStorage.getItem('portalLang'))?.lang;
            orderObj = {
                cartItems: null,
                user: null,
                bilingDetails: null,
                participants: [],
                portalName: _site,
                language: lang
            };
        } else {
            orderObj = {
                cartItems: null,
                user: null,
                bilingDetails: null,
                participants: [],
                countryCode: _site,
                language: _site.split('_')[0]
            };
        }
        if (order) {
            this.removeHouseNumberInUserObjects(order);
            // orderObj = {
            //     cartItems: cartItems,
            //     user: order.user,
            //     bilingDetails: order.billing,
            //     participants: order.participants
            // };
            orderObj.cartItems = cartItems;
            orderObj.user = order.user;
            orderObj.bilingDetails = order.billing;
            orderObj.participants = order.participants;
        }

        if (orderObj && orderObj.user && orderObj.user.salutation) {
            orderObj.user.salutation =
                typeof orderObj.user.salutation === 'string' ? orderObj.user.salutation : orderObj.user.salutation.name;
        }
        if (orderObj && orderObj.bilingDetails && orderObj.bilingDetails.salutation) {
            orderObj.bilingDetails.salutation =
                typeof orderObj.bilingDetails.salutation === 'string' ? orderObj.bilingDetails.salutation : orderObj.bilingDetails.salutation.name;
        }
        if (orderObj && orderObj.participants && orderObj.participants.length > 0) {
            orderObj.participants.forEach((object) => {
                if (object.person.salutation) {
                    object.person.salutation =
                    typeof object.person.salutation === 'string' ? object.person.salutation : object.person.salutation.name;
                }
            });
        }
  
        if (this.portalId && this.portalId.match('xyz')) {
            const SCPObject = {
                amount: totalprice,
                portalName: this.portalId.toLocaleUpperCase().replace(/-/g, '_'),
                courseIds: orderObj.cartItems.courses,
                activityIds: orderObj.cartItems.events
            };
            const _url = `${environment.APIEndpoint}api/v1/Booking/ScpDirectBooking`;
            return this._restApi.requestRawBodyPOST<any>(_url, JSON.stringify(SCPObject), null, true, true).then(
                (data) => {
                    this._$order.next([]);
                    localStorage.removeItem(`order${_site}`);
                    localStorage.removeItem(`cartItems${_site}`);
                    localStorage.removeItem('showLogin');
                    localStorage.removeItem(`itemsNumber${_site}`);
                    const _cartItems = {
                        courses: [],
                        events: [],
                        wishlist: []
                    };
                    localStorage.setItem(`cartItems${_site}`, this._urlService.encode(JSON.stringify(_cartItems)));
                    this._cartService.clearCart();
                    this.cancleOrder();
                    return true;
                },
                (error) => {
                    console.log(error);
                    return false;
                }
            );
        } else {
            const _url = `${environment.APIEndpoint}api/v1/booking`;
            return this._restApi.requestRawBodyPOST<any>(_url, JSON.stringify(orderObj), null, true, true).then(
                (data) => {
                    this._$order.next([]);
                    localStorage.removeItem(`order${_site}`);
                    localStorage.removeItem(`cartItems${_site}`);
                    localStorage.removeItem('showLogin');
                    localStorage.removeItem(`itemsNumber${_site}`);
                    const _cartItems = {
                        courses: [],
                        events: [],
                        wishlist: []
                    };
                    localStorage.setItem(`cartItems${_site}`, this._urlService.encode(JSON.stringify(_cartItems)));
                    this._cartService.clearCart();
                    this.cancleOrder();
                    if (!!data) {
                        this.getFailingCourseList(order, data);
                    }
                    return true;
                },
                (error) => {
                    console.log(error);
                    return false;
                }
            );
        }
    }

    removeHouseNumberInUserObjects(order) {
        if (order.user.houseNumber) {
            if (order.user.houseNumber !== null || order.user.houseNumber !== '') {
                order.user.address = order.user.address + ' ' + order.user.houseNumber;
            }
        }
        delete order.user['houseNumber'];

        order.participants.forEach((object) => {
            let timezone = 'unknown';
            try {
                timezone = /.*\s(.+)/.exec(new Date().toLocaleDateString(navigator.language, { timeZoneName: 'short' }))[1];
            } catch (e) {
                timezone = new Date().toTimeString().match(new RegExp('[A-Z](?!.*[(])', 'g')).join('');
            }
            object.person.timeZone = timezone;
        });
    }

    getTotalPrice() {
        this._$order.subscribe((order) => {
            let totalPrice = 0;
            order.courses.forEach((element) => {
                totalPrice += element.price as number;
            });

            return totalPrice * order.participants.length;
        });
    }

    cancleOrder() {
        let _site = this.config.getCurrentSite();
        if (this.config.isPartnerPage()) {
            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }

        this._cartService.clearCart();
        // TODO: See why it's not enough this._$order.next([]); to clear the order
        // Some subscription stays open and updateOrder is called
        // Will check it once we use the BE to populate the events within the order

        this._$order.next([]);
        const order = new Order([]);
        order.participants = [];
        const cartItems = {
            courses: [],
            events: [],
            wishlist: []
        };
        order.cartItems = [];
        localStorage.removeItem(`order${_site}`);
        localStorage.removeItem(`cartItems${_site}`);
        localStorage.removeItem('showLogin');
        localStorage.removeItem(`cartItems${_site}`);
        localStorage.removeItem(`itemsNumber${_site}`);

        order.user = null;
        order.billing = null;

        this.updateOrder(order);
        this._$order.next([]);
        localStorage.removeItem(`order${_site}`);

        localStorage.setItem(`cartItems${_site}`, this._urlService.encode(JSON.stringify(cartItems)));
        localStorage.removeItem('showLogin');
    }

    public getEmployees() {
        const url = `${env.APIEndpoint}api/v1/user/getemployees`;

        return this._restApiService.requestGET<any>(url, null, false, true).then(
            (employees) => {
                return employees;
            },
            (error) => {
                return error;
            }
        );
    }

    getFailingCourseList(order, data) {
        const failingCoursesObject = data;
        order.cartItems.forEach((course) => {
            if (failingCoursesObject.courseIds.length > 0) {
                failingCoursesObject.courseIds.forEach((courseId) => {
                    if (courseId === course.courseId && this.failingCourseList.indexOf(course.courseName) === -1) {
                        this.failingCourseList.push(course.courseName);
                    }
                });
            }
            if (failingCoursesObject.activityIds.length > 0) {
                failingCoursesObject.activityIds.forEach((activityId) => {
                    if (activityId === course.externalId && this.failingCourseList.indexOf(course.courseName) === -1) {
                        this.failingCourseList.push(course.courseName);
                    }
                });
            }
            if (failingCoursesObject.wishList.length > 0) {
                failingCoursesObject.wishList.forEach((wishListItem) => {
                    if (wishListItem === course.courseId && this.failingCourseList.indexOf(course.courseName) === -1) {
                        this.failingCourseList.push(course.courseName);
                    }
                });
            }
        });
        localStorage.setItem('failingCourseList', JSON.stringify(this.failingCourseList));
    }
}
